import React, { useState } from 'react';
import Card, { CardTitle } from '../Card';
import PatchHeader from './patchHeader';
import TableView from './TableView';

type Mode = 'OnDemand' | 'Automated';

const AvailabilityTableView = ({ viewFunction, mode, setMode }) => {
  return (
    <div className=" flex-1" style={{ backgroundColor: 'rgb(7, 7, 7)' }}>
      <div className="flex flex-1 flex-col p-2">
        <PatchHeader view={1} viewFunction={viewFunction} mode={mode} setMode={setMode} />
        <TableView mode={mode} />
      </div>
    </div>
  );
};
export default AvailabilityTableView;
